export default "__VITE_ASSET__C$LCyZdp__"